import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from 'react-i18next'; 
import Footer from "./Footer";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

const FAQ = () => {
const { t } = useTranslation();
const [activeIndex, setActiveIndex] = useState(null); 
const navigate = useNavigate();

const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
};

const faqData = [
    {
    question: <p>{t('faq.ques1')}</p>,
    answer: <p>{t('faq.ans1')}</p>,
    },
    {
    question: <p>{t('faq.ques2')}</p>,
    answer: <p>{t('faq.ans2')}</p>,
    },
    {
    question: <p>{t('faq.ques3')}</p>,
    answer: <p>{t('faq.ans3')}</p>,
    },
    {
    question: <p>{t('faq.ques4')}</p>,
    answer: <p>{t('faq.ans4')}</p>,
    },
    {
    question: <p>{t('faq.ques5')}</p>,
    answer: <p>{t('faq.ans5')}</p>,
    },
    {
      question: <p>{t('faq.ques6')}</p>,
      answer: <p>{t('faq.ans6')}</p>,
    },
    {
      question: <p>{t('faq.ques7')}</p>,
      answer: <p>{t('faq.ans7')}</p>,
    },{
      question: <p>{t('faq.ques8')}</p>,
      answer: <p>{t('faq.ans8')}</p>,
    },
];
return (
    <div>
    <Header />
    <FAQdiv> 
        <div className="faq-section">
        <h1>{t('footer.FAQ')}</h1>
        <div className="faq-list">
            {faqData.map((item, index) => (
            <div key={index} className="faq-item">
                <div className="faq-question" onClick={() => toggleAnswer(index)}>
                <span>{item.question}</span>
                <span className="faq-toggle-icon">{activeIndex === index ? '-' : '+'}</span>
                </div>
                {activeIndex === index && (
                <div className="faq-answer">
                    <p>{item.answer}</p>
                </div>
                )}
            </div>
            ))}
        </div>
        </div>
        <UnansweredQ>{t("faq.unanswered")}</UnansweredQ>
        <Contactbutton onClick={() => navigate("/contact")}>{t("faq.contact")}</Contactbutton>
    </FAQdiv>
    <Footer />
    </div>
);
};

export default FAQ;

const FAQdiv = styled.div`
  padding-top: 70px;
  text-align: center;
  padding-bottom: 100px;
  background: linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);

  .faq-section {
    padding: 20px;
    margin: 0 auto;
    max-width: 1000px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .faq-list {
    list-style-type: none;
    padding: 0;
  }

  .faq-item {
    border-bottom: 1px solid #eee;
    padding: 15px 0;
  }

  .faq-question {
    display: flex;
    justify-content: space-between;
    font-size: 1.2rem;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease;
  }

  .faq-question:hover {
    color:rgba(217,121,97,1);
  }

  .faq-toggle-icon {
    font-size: 1.5rem;
    font-weight: bold;
    color:rgba(148,163,135,1);
  }

  .faq-answer {
    padding-top: 10px;
    font-size: 1rem;
    color: #555;
  }

  .rating-section {
    display: flex;
    flex-direction: column;
    align-items: center;  
    justify-content: center; 
    padding: 20px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-top: 30px;
  }

  @media (max-width: 480px) {
    padding-bottom: 300px; /* Extra space on mobile */
  }
`;
const UnansweredQ = styled.p`
font-size: 20px;
`
const Contactbutton = styled.button`
padding: 10px;
background-color: rgba(217,121,97,1);
color: white;
border: none;
box-shadow: 0 4px 24px white;
font-size: 18px;
border-radius: 10px;
margin-bottom: 50px;
cursor: pointer;
`
